import type { Invoice } from '@/store/expenses-store/invoices/invoices.dto';

/**
 * How to reach a recipient typed in by hand rather than picked from the service providers.
 * Wallet has no columns for it, so it rides in `detail.recipient`; the name itself is the
 * invoice's `company_name`.
 */
export type InvoiceRecipientContact = { email?: string; phone?: string };

/** A name with no provider behind it: the invoice was recorded against a custom recipient. */
export const isCustomRecipient = (
  invoice?: Pick<Invoice, 'service_provider_id' | 'company_name'> | null,
) => !!invoice && !invoice.service_provider_id && !!invoice.company_name;

export const invoiceRecipientContact = (
  invoice?: Pick<Invoice, 'service_provider_id' | 'company_name' | 'detail'> | null,
): InvoiceRecipientContact => {
  if (!isCustomRecipient(invoice)) return {};
  const { email, phone } = (invoice?.detail?.recipient ?? {}) as InvoiceRecipientContact;
  return { email: email || undefined, phone: phone || undefined };
};

/** "name@example.com · +1 555 000 0000", or '' when neither was given. */
export const formatRecipientContact = ({ email, phone }: InvoiceRecipientContact) =>
  [email, phone].filter(Boolean).join(' · ');
